import React from 'react'
import classNames from 'classnames'

import Link from '../Link'
import Person from '../Person'

const LotItem = ({ data, type, onAfterClick, position }) => <Person onClick={onAfterClick} data={data} isSpecial 
  type={type === 'lot' ? 'lot' : 'member'} linkPrefix={type === 'lot' ? 'lots' : 'members'} position={position} listName={'Поиск'}/>
const FundItem = ({ data, onAfterClick }) => <Link onClick={onAfterClick} to={ data._id != "5b30b97a7a86d3354a414b50"? `/funds/${data._id}` : '/aboutus'} className='Search__result-item Link Link_light'>{data.name}</Link>

const elemTypes = { fund: FundItem, lot: LotItem, person: LotItem }

const SearchResult = ({ title, items = [], type = '', onAfterClick }) => {
  const Entry = elemTypes[type]
  if (!items.length || !Entry) return null
  let position = 0;
  return (
    <div className='Search__result-list'>
      <span className='Search__result-head Text'>{title} ({items.length})</span>
      <div className={classNames({ 'Search__result-lot-list': type !== 'fund' })}>
        {items.map(el => {
          if (type == 'lot') position++;
        return <Entry data={el} key={el._id} onAfterClick={onAfterClick} type={type} position={position}/>
      })}
      </div>
    </div>
  )
}

export default SearchResult



// WEBPACK FOOTER //
// ./src/components/Search/Result.jsx